class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if( event.target.closest('details').classList.contains("header__search-details")) {

      let menu_drawer = document.getElementById("Details-menu-drawer-container");

      if (menu_drawer && menu_drawer.hasAttribute("open")) {
        let summaryElement = menu_drawer.querySelector("summary");
        if (summaryElement && summaryElement.getAttribute('aria-expanded') === 'true') {
            summaryElement.setAttribute("aria-expanded", false);
            menu_drawer.open = false;
        }
      }
    }
    if (event.target.closest('details').hasAttribute('open')) {
      this.close();
      document.body.classList.remove('overflow-hidden');
    } else {
      this.open(event);
      document.body.classList.add('overflow-hidden');
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    
    //This resolves an issue with search icon not opening search modal
    //when scrolled down on the page, on windows devices
    if (!navigator.userAgent.includes("Win")) {
      document.body.classList.add('overflow-hidden');
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
